import { render, staticRenderFns } from "./LayerRatiosConfig.vue?vue&type=template&id=e3cc0bb4"
import script from "./LayerRatiosConfig.vue?vue&type=script&lang=js"
export * from "./LayerRatiosConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports